(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  const mainImage = document.getElementById('ProductMainImage');
  const thumbs = document.querySelectorAll('.product-page__thumb');

  if (mainImage && thumbs.length) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.imageSrc;
        const img = mainImage.querySelector('img');
        if (img && src) {
          img.src = src;
          img.srcset = '';
        }
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
